import mapPrismicImageProxy from '@/utils/prismic/mapPrismicImageProxy';

import type {
    PartnersDataType,
    PrismicPartnersType,
} from '../SectionShopSearch.types';

export const mapAllPartnersList = (
    partnersData: PrismicPartnersType[],
): PartnersDataType[] =>
    partnersData.map(({ firstPublicationDate, id, images, name, url }) => {
        const partnerLogo = images.filter(image => image.type === 'logo');

        const logoProxy = partnerLogo[0]?.url
            ? mapPrismicImageProxy(partnerLogo[0]?.url)
            : '';

        return {
            id,
            partnerName: name,
            partnerShopLink: url,
            partnerLogo: logoProxy,
            firstPublicationDate,
        };
    });
